import React, { useCallback, FC, ReactNode, FormEvent } from "react";
import cn from "classnames";
import { useFormikContext } from "formik";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";

interface Props {
  children: ReactNode;
  className?: string;
  isLoading?: boolean;
}

export const AuthFormButton: FC<Props> = ({
  children,
  className,
  isLoading,
}) => {
  const { isValid, handleSubmit } = useFormikContext();

  const onClick = useCallback(
    (e: FormEvent) => {
      e.preventDefault();
      handleSubmit();
    },
    [handleSubmit]
  );

  return (
    <Button
      className={cn("w-full px-5 py-2 rounded-20", className)}
      type="submit"
      variant={ButtonVariants.PRIMARY}
      isDisabled={!isValid}
      isLoading={isLoading}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};
